import { Input, message, Select } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BackIcon } from "../../../asset";
import PrimaryButton from "../../../component/button/PrimaryButton";
import SecondaryButton from "../../../component/button/SecondaryButton";
import style from "./AdditionalProofsAdd.module.css";
import axios from "axios"
import { ROUTES } from "../../../constant/routeConstant";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash"
import { GROLOG_URL } from "../../../constant/apiConstant";
import { validAdditional } from "./validation";
import ModalSuccessAdd from "../../../component/modal/ModalSuccessAdd";
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import ModalConfirmLeave from "../../../component/modal/ModalConfirmLeave";
import { useDispatch, useSelector } from "react-redux";
import { onChanged } from "../../../util/Util";

const AdditionalProofsEdit = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`; 
  const api = GROLOG_URL
  const { t } = useTranslation();
  const navigate = useNavigate()
  const location = useLocation()
  const [detail, setDetail] = useState([])
  const [error, setError] = useState([]);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [err,setErr] = useState("")
  const [change, setChange] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const dispatch = useDispatch()

  useEffect(() => {
    fetchData()
  }, []);


  const doPut = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "PUT";
    const headers = { "Authorization": token };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doGet = async(endpoint, tkn, params, dispatch,refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = {'Authorization' : token };
    const request = { url, method,headers, params };
    return axios(request);
  };

  const fetchData =async() =>{
    let res = await doGet(
      `/additional-proofs/${location.state}`,token
    );
    setDetail(res?.data?.payload?.data);
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const handleChange = (val, name) =>{
    setChange(true)
    onChanged(dispatch, true)
    setErr("")
    if(name==="to_menu"){
      setDetail((prevsValue)=>{
        return{
        ...prevsValue,
        [name]:val
        }
      })
    }else{
      let eror = validAdditional(name, val.target.value, t);
      setError({ ...error, ...eror });
      setDetail((prevsValue) => {
        return {
          ...prevsValue,
          [name]: val.target.value,
        };
      });
  }
}

  
  const validateSubmit = (error) => {
    for (const key in error) {
      if (Object.hasOwnProperty.call(error, key)) {
        if (error[key]) return false;
      }
    }
    return true;
  };

  const onSubmit = async () => {
    let sub = {
        ...detail,
    }
    let keys={...detail}
    let errors ={}

    for (const key in keys) {
      const option = validAdditional(key, keys[key], t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      try{
        let res = await doPut(`/additional-proofs/${location.state}?${param}`, token, sub);
        
        setSuccessModalOpen(true)
      }catch(err){
        if(err.response.data.payload.message === "Data with this Additional Name is already used by other, cant process this action"){
          setErr(err.response.data.payload.message)
        }else{
        message.error(_.startCase(err.response.data.payload.message));
        }
      }
    }
  };

  const backToList = () => {
    navigate(ROUTES.ADDITIONAL_PROOFS.LIST);
  };

  const actModal = ()=>{
    setSuccessModalOpen(false)
    navigate({
      pathname: ROUTES.ADDITIONAL_PROOFS.LIST,
   });
  }
  return (
    <>
     <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.ADDITIONAL_PROOFS.LIST}
      />
     <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your data has been updated"
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        
        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`Additional Proofs`}
          menuLevel4={`Edit Additional Proofs`}
        />

        <div className="flex items-center justify-between">
        <div
            onClick={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.ADDITIONAL_PROOFS.LIST)
            }
            className="flex items-center gap-[22px] cursor-pointer"
          >
            <img src={BackIcon} alt="" className="cursor-pointer" />
            <h1 className="font-sans-bold text-2xl" id="title">
              Edit Additional Proofs
            </h1>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <div className="flex">
              <div>
                {/* <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
              {t("ADDITIONAL_PROOFS:DRIVER_PROFILE")}
            </h3> */}
                <div className="flex">
                <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                    {t("ADDITIONAL_PROOFS:ADDITIONAL_PROOFS_INFO")}
                  </h3>
                </div>

                {/* //one */}
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("ADDITIONAL_PROOFS:ADDITIONAL_NAME")}
                  </label>
                  <div className="flex w-[500px]">
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    value={detail?.additional_name} 
                    status={error?.additional_name || err ? "error" : ""}
                            
                    onChange={(value) => handleChange(value, "additional_name")}
                  />
                  </div>
                        <div className="text-red-100">{err ? err :error?.additional_name}</div>
                  </div>

                  <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("ADDITIONAL_PROOFS:ADDITIONAL_DESCRIPTION")}
                  </label>
                  <div className="flex w-[500px]">
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    value={detail?.description}
                    status={error?.description ? "error" : ""}
                    onChange={(value) => handleChange(value, "description")}
                  />
                  </div>
                        <div className="text-red-100">{error?.description}</div>
                  </div>

                  <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("ADDITIONAL_PROOFS:ADDITIONAL_TO_MENU")}
                  </label>
                  <div
                    className="mt-[8px] h-[47px] w-[500px]">
                  <Select
                    className="w-[500px]"
                    status={error?.to_menu ? "error" : ""}
                    dropdownStyle={{ backgroundColor: 'white' }}
                    size="large"
                    value={detail?.to_menu}
                    disabled={detail.to_menu}
                    onChange={(value) => handleChange(value, "to_menu")}
                    options={[
                      { value: 'Driver', label: 'Driver' },
                      { value: 'Delivery Associate', label: 'Delivery Associate' },
                      { value: 'Vehicle', label: 'Vehicle' }
                    ]}
                  />
                  </div>
                </div>

                </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-row-reverse gap-[16px]">
          <PrimaryButton text={t("USER_DETAIL:SAVE")} action={()=>onSubmit()} />
          <SecondaryButton text={t("USER_DETAIL:CANCEL")} action={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.ADDITIONAL_PROOFS.LIST)
            } />
        </div>
      </div>
    </>
  );
};
export default AdditionalProofsEdit;
